import { fabric } from 'fabric';

export const hideMagicFrameCustomControls = () => {
  if (fabric.MagicFrame.prototype.controls.replacePhoto) {
    fabric.MagicFrame.prototype.controls.replacePhoto.setVisibility(false);
  }

  if (fabric.MagicFrame.prototype.controls.modifyPhoto) {
    fabric.MagicFrame.prototype.controls.modifyPhoto.setVisibility(false);
  }
};
